export const ON_COUNT_DOWN_FINISH = "ON_COUNT_DOWN_FINISH";

export function onCountdownFinish() {
  return {
    type: ON_COUNT_DOWN_FINISH,
    payload: {},
  };
}
